// src/utils/authErrors.js

export const firebaseErrorMessagesFR = {
  'auth/invalid-email': "L'email n'est pas valide.",
  'auth/missing-email': 'Email manquant.',
  'auth/user-disabled': 'Ce compte est désactivé.',
  'auth/user-not-found': "Aucun compte trouvé pour cet email.",
  'auth/wrong-password': 'Mot de passe incorrect.',
  'auth/email-already-in-use': 'Email déjà utilisé.',
  'auth/too-many-requests': 'Trop de tentatives. Réessayez plus tard.',
  'auth/popup-closed-by-user': 'Fenêtre fermée avant la connexion.',
  'auth/cancelled-popup-request': 'Une autre tentative est en cours.',
  'auth/operation-not-allowed': "La connexion e‑mail/mot de passe n'est pas activée dans Firebase.",
  'auth/invalid-credential': 'Identifiants invalides. Vérifiez votre email et mot de passe.',
  'auth/invalid-login-credentials': 'Identifiants invalides. Vérifiez votre email et mot de passe.',
  'auth/admin-restricted-operation': "Opération restreinte par l'administrateur. Activez la méthode E‑mail/Mot de passe dans Firebase.",
  'auth/invalid-continue-uri': 'URL de redirection invalide (continue URL).',
  'auth/unauthorized-continue-uri': 'Le domaine de redirection n’est pas autorisé dans Firebase.',
  'auth/missing-continue-uri': 'URL de redirection manquante.',
  'auth/invalid-recipient-email': "L'adresse email du destinataire est invalide.",
  'auth/invalid-sender': "L'adresse expediteur des emails n'est pas correctement configurée.",
  'auth/invalid-message-payload': 'Le template d’email est invalide ou manquant.',
};

export const mapFirebaseErrorToMessage = (error) => {
  const code = error?.code || '';
  return firebaseErrorMessagesFR[code] || error?.message || 'Une erreur est survenue.';
};
